import * as React from 'react'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Row } from './Row/Row'
import { IForm } from '@user/store/agreements/typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { selectAllAgreementForms } from '@user/store/agreements/slice'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdate: boolean
  openAgreementCreateDrawer?: () => void
}

export const AgreementsDrawerTable: FC<Props> = (props: Props) => {
  const agreements = useSelector(selectAllAgreementForms)
  const { entityId, entityType, canUpdate, openAgreementCreateDrawer } = props

  return (
    <>
      {!agreements.length && (
        <Box p={2}>
          <Alert severity="info">
            There are currently no agreements associated with this{' '}
            {entityType.toLowerCase()}.
          </Alert>
        </Box>
      )}

      {agreements.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Date Created</b>
              </TableCell>
              <TableCell>
                <b>Created By</b>
              </TableCell>
              <TableCell>
                <b>Agreement Name</b>
              </TableCell>
              <TableCell>
                <b>Status</b>
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agreements.map((agreement: IForm) => (
              <Row
                agreement={agreement}
                entityId={entityId}
                entityType={entityType}
                key={agreement.id}
                canUpdate={canUpdate}
                openAgreementCreateDrawer={openAgreementCreateDrawer}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  )
}
